import React from 'react';
import { observer } from 'mobx-react';
import DeviceTelemetryComponent from './Device-telemetry.component';
import useDeviceTelemetry from './useDeviceTelemetry';
import { rootStore } from '@store/Root.store';

const Container: React.FC = () => {
        const { app, user, lang, telemetry, state, refs, values, handlers } =
        useDeviceTelemetry();
        return (
            <>
                <DeviceTelemetryComponent
                    page={state.page}
                    lang={lang.lang}
                    loading={telemetry.loading}
                    isTelemetryVisible={
                        telemetry.isTelemetryVisible && app.mainWindow === 'map'
                    }
                    telemetryList={telemetry.currentTelemetry}
                    timezone={user.settings.timezone ?? 0}
                    limit={telemetry.limit}
                    serverError={telemetry.serverError}
                    sortModel={telemetry.sortModel}
                    columnVisibilityModel={telemetry.columnVisibilityModel}
                    visibilitySettingsState={state.visibilitySettingsState}
                    visibilitySettingsEl={state.visibilitySettingsEl}
                    visibilitySettingsRef={refs.visibilitySettingsRef}
                    columns={values.columns}
                    rows={values.rows}
                    onPageChange={handlers.handlePageChange}
                    onClose={handlers.handleClose}
                    onDownloadClick={handlers.handleDownloadClick}
                    onRowClick={handlers.handleRowClick}
                    onSortModelChange={handlers.handleSortModelChange}
                    onUnsort={handlers.handleUnsort}
                    onAscSort={handlers.handleAscSort}
                    onDescSort={handlers.handleDescSort}
                    onHideCol={handlers.handleHideCol}
                    onToggleCol={handlers.handleToggleCol}
                    onVisibilitySettingsStateChange={
                        handlers.handleVisibilitySettingsStateChange
                    }
                    onVisibilitySettingsStateClose={
                        handlers.handleVisibilitySettingsStateClose
                    }
                    onShowAllCol={handlers.handleShowAllCol}
                    onHideAllCol={handlers.handleHideAllCol}
                    onLimitChange={handlers.handeLimitChange}
                />
            </>
        );
    //}
};

const DeviceTelemetryContainer = observer(Container);

export default DeviceTelemetryContainer;
